/* HOPE theme JS — cart drawer, product form, misc UI */
(function () {
  'use strict';

  /* ---------- helpers ---------- */

  function formatMoney(cents) {
    var format = window.themeSettings && window.themeSettings.moneyFormat ? window.themeSettings.moneyFormat : 'Rs. {{amount}}';
    var amount = (cents / 100);
    var value;
    if (format.indexOf('no_decimals') !== -1) {
      value = Math.round(amount).toLocaleString('en-IN');
    } else if (amount % 1 === 0) {
      value = amount.toLocaleString('en-IN');
    } else {
      value = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('Toast');
    if (!el) return;

    // A phone carries the buy bar along the bottom of a product page, and the
    // toast was landing on top of it — over the two buttons it was reporting
    // on. Measured rather than guessed, because that bar is a different height
    // depending on whether it is asking for a size or offering to buy.
    var bar = document.querySelector('.sticky-atc');
    var clear = 0;
    if (bar && getComputedStyle(bar).display !== 'none') {
      clear = bar.getBoundingClientRect().height + 14;
    }
    el.style.bottom = clear ? (26 + clear) + 'px' : '';

    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2400);
  }

  /* ---------- cart drawer ---------- */

  function drawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // Only now does the rail have a width to measure, so autoplay can start.
    if (typeof startRailsIn === 'function') startRailsIn(d);
  }

  function closeDrawer() {
    var d = drawer();
    if (d) { d.hidden = true; document.documentElement.style.overflow = ''; }
  }

  function renderDrawer(html) {
    var wrap = document.getElementById('shopify-section-cart-drawer');
    if (!wrap || html == null) return;
    var wasOpen = drawer() && !drawer().hidden;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp;
    wrap.innerHTML = fresh.innerHTML;
    // The markup above is brand new, so its carousel has no listeners yet.
    initRails(wrap);
    if (wasOpen) openDrawer();
    syncHeaderCount();
  }

  function syncHeaderCount() {
    var d = drawer();
    if (!d) return;
    var count = parseInt(d.getAttribute('data-cart-count') || '0', 10);
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function changeLine(line, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- quick view (mobile "+" on product cards) ---------- */

  var qv = { data: null, colorIndex: -1, sizeIndex: -1, selectedColor: null, selectedSize: null };

  function qvPanel() { return document.getElementById('QuickView'); }

  function qvMatch() {
    var data = qv.data;
    if (!data) return null;
    return data.variants.find(function (v) {
      if (qv.colorIndex >= 0 && v.options[qv.colorIndex] !== qv.selectedColor) return false;
      if (qv.sizeIndex >= 0 && v.options[qv.sizeIndex] !== qv.selectedSize) return false;
      return v.available;
    }) || null;
  }

  function recomputeQuickView() {
    var panel = qvPanel();
    if (!panel || !qv.data) return;
    var priceEl = panel.querySelector('[data-qv-price]');
    var addBtn = panel.querySelector('[data-qv-add]');
    var sizesBox = panel.querySelector('[data-qv-sizes]');

    if (sizesBox && qv.data.sizes) {
      Array.prototype.forEach.call(sizesBox.children, function (btn, i) {
        var sz = qv.data.sizes[i];
        var ok = qv.data.variants.some(function (v) {
          if (qv.colorIndex >= 0 && v.options[qv.colorIndex] !== qv.selectedColor) return false;
          return v.options[qv.sizeIndex] === sz && v.available;
        });
        btn.classList.toggle('is-disabled', !ok);
      });
    }

    var match = qvMatch();
    var needsSize = qv.sizeIndex >= 0 && !qv.selectedSize;

    if (match) {
      if (priceEl) {
        priceEl.innerHTML = formatMoney(match.price) +
          (match.compareAtPrice > match.price ? ' <s>' + formatMoney(match.compareAtPrice) + '</s>' : '');
      }
      if (addBtn) { addBtn.setAttribute('data-add-variant', match.id); addBtn.textContent = 'Add to Bag'; }
    } else {
      if (priceEl) priceEl.textContent = formatMoney(qv.data.variants[0].price);
      if (addBtn) { addBtn.removeAttribute('data-add-variant'); addBtn.textContent = needsSize ? 'Select a size' : 'Sold out'; }
    }
  }

  function openQuickView(data) {
    var panel = qvPanel();
    if (!panel) return;
    qv.data = data;
    qv.colorIndex = data.colorIndex;
    qv.sizeIndex = data.sizeIndex;
    qv.selectedColor = (data.colors && data.colors.length) ? data.colors[0].name : null;
    qv.selectedSize = null;

    var titleEl = panel.querySelector('[data-qv-title]');
    if (titleEl) { titleEl.textContent = data.title; titleEl.href = data.url; }
    var viewEl = panel.querySelector('[data-qv-view-details]');
    if (viewEl) viewEl.href = data.url;

    var img1 = panel.querySelector('[data-qv-img-1]');
    var img2 = panel.querySelector('[data-qv-img-2]');

    // Show a colour's own photos in both slots. Changing only the first left the
    // second showing the colour the customer had just moved away from. A colour
    // with nothing alt-tagged falls back to the product's two photos, which is
    // what the drawer did before any of this was tagged.
    var prevShot = panel.querySelector('[data-qv-prev]');
    var nextShot = panel.querySelector('[data-qv-next]');
    var shotList = [];
    var shotAt = 0;

    // On a wide screen one photograph shows at a time and the arrows move
    // through them; on a phone the sheet keeps its two side by side, where
    // there is width for both and no height to give either. The list is held
    // here either way so the arrows have something to walk.
    function paintShot() {
      if (img1 && shotList.length) { img1.src = shotList[shotAt]; img1.alt = data.title; }
      var many = shotList.length > 1;
      if (prevShot) prevShot.hidden = !many;
      if (nextShot) nextShot.hidden = !many;
    }

    function stepShot(by) {
      if (shotList.length < 2) return;
      shotAt = (shotAt + by + shotList.length) % shotList.length;
      paintShot();
    }

    if (prevShot) prevShot.addEventListener('click', function () { stepShot(-1); });
    if (nextShot) nextShot.addEventListener('click', function () { stepShot(1); });

    function showColorImages(color) {
      var shots = (color && color.images) || [];
      shotList = shots.length ? shots.slice() : [data.image, data.altImage].filter(Boolean);
      // Back to the first photograph: a colour changed while looking at the
      // third shot of the last one would otherwise open on whatever happened
      // to sit third in the new colour.
      shotAt = 0;
      paintShot();

      if (!img2) return;
      var second = shotList[1];
      if (second) { img2.src = second; img2.alt = ''; img2.hidden = false; }
      else { img2.hidden = true; }
    }

    showColorImages(data.colors && data.colors.length ? data.colors[0] : null);

    var colorsWrap = panel.querySelector('[data-qv-colors-wrap]');
    var colorsBox = panel.querySelector('[data-qv-colors]');
    var colorNameEl = panel.querySelector('[data-qv-color-name]');
    if (colorsBox) colorsBox.innerHTML = '';
    if (data.colors && data.colors.length) {
      if (colorsWrap) colorsWrap.hidden = false;
      if (colorNameEl) colorNameEl.textContent = qv.selectedColor;
      data.colors.forEach(function (c, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'opt-swatch' + (i === 0 ? ' is-active' : '') + (c.available === false ? ' is-disabled' : '');
        btn.title = c.name;
        btn.setAttribute('aria-label', c.name);
        // Round chip of the actual colour — the product photo belongs in the
        // gallery above, not on the swatch.
        btn.style.background = c.swatch || 'var(--wash)';
        btn.addEventListener('click', function () {
          qv.selectedColor = c.name;
          colorsBox.querySelectorAll('.opt-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (colorNameEl) colorNameEl.textContent = c.name;
          showColorImages(c);
          recomputeQuickView();
        });
        colorsBox.appendChild(btn);
      });
    } else if (colorsWrap) {
      colorsWrap.hidden = true;
    }

    var sizesWrap = panel.querySelector('[data-qv-sizes-wrap]');
    var sizesBox = panel.querySelector('[data-qv-sizes]');
    if (sizesBox) sizesBox.innerHTML = '';
    if (data.sizes && data.sizes.length) {
      if (sizesWrap) sizesWrap.hidden = false;
      data.sizes.forEach(function (sz) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'opt-pill';
        btn.textContent = sz;
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-disabled')) return;
          qv.selectedSize = sz;
          sizesBox.querySelectorAll('.opt-pill').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          recomputeQuickView();
        });
        sizesBox.appendChild(btn);
      });
    } else if (sizesWrap) {
      sizesWrap.hidden = true;
    }

    var errEl = panel.querySelector('[data-qv-error]');
    if (errEl) errEl.hidden = true;

    recomputeQuickView();

    panel.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeQuickView() {
    var panel = qvPanel();
    if (panel) panel.hidden = true;
    document.documentElement.style.overflow = '';
  }

  // The sheet's data used to ride along inside every card. A listing carries
  // fifty-odd cards and opens at most one sheet, so that was fifty-odd copies
  // built, sent and parsed to serve the one click that might come — forty
  // kilobytes a card on a co-ord with eleven colours and 250 variants. Now the
  // card carries only a URL and the click fetches it.
  //
  // Kept once fetched: reopening the same card is then instant, which is how it
  // behaved when the data was in the page.
  var qvCache = {};

  function openQuickViewFor(button) {
    var url = button.getAttribute('data-qv-url');
    if (!url) return;

    if (qvCache[url]) { openQuickView(qvCache[url]); return; }

    // A second click while the first is still in the air would otherwise ask
    // twice and open twice.
    if (button.getAttribute('data-qv-loading')) return;
    button.setAttribute('data-qv-loading', '1');

    // No Accept header: the ?view= is what picks the template, and asking for
    // JSON invites the shop to content-negotiate its own answer instead.
    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('quick view ' + res.status);
        return res.json();
      })
      .then(function (data) {
        qvCache[url] = data;
        openQuickView(data);
      })
      .catch(function () {
        // Offline, or the shop answered with something else. The product page
        // can do everything this sheet can, so send them there rather than
        // leaving a button that does nothing.
        var link = button.closest('.pcard');
        var href = link && link.querySelector('a[href]');
        if (href) window.location.href = href.getAttribute('href');
      })
      .then(function () {
        button.removeAttribute('data-qv-loading');
      });
  }

  /* ---------- fit finder ---------- */

  // The shopper's size is kept in the browser so every product page afterwards
  // can open on it. A preference, not an account: nothing leaves the device.
  var FIT_SIZE_KEY = 'hope:fit-size';
  var FIT_FROM_KEY = 'hope:fit-from';

  function readFitSize() {
    try { return window.localStorage.getItem(FIT_SIZE_KEY) || ''; } catch (err) { return ''; }
  }

  function writeFitSize(size) {
    try { window.localStorage.setItem(FIT_SIZE_KEY, size); } catch (err) { /* private mode */ }
  }

  // "M" has to match a size written "M-40" on the product, so compare the part
  // before the measurement as well as the whole thing.
  function fitSizeMatches(optionValue, wanted) {
    if (!optionValue || !wanted) return false;
    var a = String(optionValue).trim().toUpperCase();
    var b = String(wanted).trim().toUpperCase();
    if (a === b) return true;
    return a.split(/[-–/(]/)[0].trim() === b;
  }

  document.querySelectorAll('[data-fit-finder]').forEach(function (finder) {
    var steps = finder.querySelectorAll('[data-fit-step]');
    var adjust = 0;
    var anchor = null;
    var shoppingFor = 'any';

    var pools = {};
    var poolsEl = finder.querySelector('[data-fit-products]');
    if (poolsEl) {
      try { pools = JSON.parse(poolsEl.textContent) || {}; } catch (err) { pools = {}; }
    }

    // Whatever they said they were shopping, falling back to everything —
    // "either", or a side of the shop with no collection set behind it.
    function suggestProduct() {
      var card = finder.querySelector('[data-fit-product]');
      if (!card) return;

      var chosen = (pools[shoppingFor] || []).slice();
      if (!chosen.length) {
        Object.keys(pools).forEach(function (k) { chosen = chosen.concat(pools[k] || []); });
      }
      if (!chosen.length) { card.hidden = true; return; }

      var pick = chosen[Math.floor(Math.random() * chosen.length)];
      var img = card.querySelector('[data-fit-product-image]');
      var title = card.querySelector('[data-fit-product-title]');
      var line = card.querySelector('[data-fit-product-line]');
      if (img) { img.src = pick.image || ''; img.alt = pick.title || ''; }
      if (title) title.textContent = pick.title || '';
      if (line) line.textContent = pick.line || '';
      card.href = pick.url || '#';
      card.hidden = false;
    }

    function goto(name) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-fit-step') !== String(name); });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Every size the shopper could have been offered, in order, so "roomier"
    // and "neater" mean one step along the list they just chose from.
    function anchorSizes() {
      return Array.prototype.map.call(
        finder.querySelectorAll('[data-fit-anchor]'),
        function (b) { return b.getAttribute('data-fit-anchor'); }
      );
    }

    function decide() {
      var sizes = anchorSizes();
      var i = sizes.indexOf(anchor);
      if (i < 0) return anchor;
      return sizes[Math.min(sizes.length - 1, Math.max(0, i + adjust))];
    }

    function finish() {
      var size = decide();
      var sizeEl = finder.querySelector('[data-fit-size]');
      var reasonEl = finder.querySelector('[data-fit-reason]');
      if (sizeEl) sizeEl.textContent = size;
      if (reasonEl) {
        reasonEl.textContent = adjust > 0 ? ' — sized up for the ease you asked for'
          : adjust < 0 ? ' — sized down for the neater line' : '';
      }
      var applyBtn = finder.querySelector('[data-fit-apply]');
      if (applyBtn) {
        applyBtn.setAttribute('data-fit-chosen', size);
        var applyLabel = applyBtn.getAttribute('data-fit-apply-label');
        if (!applyLabel) {
          applyLabel = applyBtn.textContent.trim();
          applyBtn.setAttribute('data-fit-apply-label', applyLabel);
        }
        applyBtn.textContent = applyLabel + ' ' + size;
      }
      writeFitSize(size);
      suggestProduct();
      goto('result');
    }

    finder.addEventListener('click', function (e) {
      var el;

      if ((el = e.target.closest('[data-fit-answer]'))) {
        adjust = parseInt(el.getAttribute('data-fit-answer'), 10) || 0;
        goto(2);
        return;
      }

      if ((el = e.target.closest('[data-fit-anchor]'))) {
        anchor = el.getAttribute('data-fit-anchor');
        // Straight to the verdict when the optional step is switched off.
        if (finder.querySelector('[data-fit-step="3"]')) goto(3);
        else finish();
        return;
      }

      if ((el = e.target.closest('[data-fit-gender]'))) {
        shoppingFor = el.getAttribute('data-fit-gender');
        finder.querySelectorAll('[data-fit-gender]').forEach(function (b) {
          b.classList.toggle('is-active', b === el);
        });
        return;
      }

      if (e.target.closest('[data-fit-helper-toggle]')) {
        var helper = finder.querySelector('[data-fit-helper]');
        if (helper) helper.hidden = !helper.hidden;
        return;
      }

      if ((el = e.target.closest('[data-fit-goto]'))) {
        goto(el.getAttribute('data-fit-goto'));
        return;
      }

      if (e.target.closest('[data-fit-finish]')) { finish(); return; }

      if ((el = e.target.closest('[data-fit-apply]'))) {
        e.preventDefault();
        var target = el.getAttribute('data-fit-apply-href') || '/';

        // Only when the shop asked for it: back to the product they opened the
        // finder from, since that is the one they were deciding about.
        if (el.hasAttribute('data-fit-apply-prefers-origin')) {
          var from = '';
          try { from = window.sessionStorage.getItem(FIT_FROM_KEY) || ''; } catch (err) { /* ignore */ }
          if (from) target = from;
        }

        window.location.href = target;
        return;
      }
    });
  });

  // Someone who has already answered is told what they answered, rather than
  // being asked again as though the finder had never happened.
  document.querySelectorAll('[data-fit-link]').forEach(function (link) {
    var known = readFitSize();
    if (!known) return;
    var template = link.getAttribute('data-fit-link-known');
    if (!template) return;
    link.textContent = template.replace('[size]', known);
  });

  // Remember the product someone opened the finder from, so the verdict can
  // send them back to it rather than to the shop's front door.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="fit-finder"], [data-fit-link]');
    if (!link) return;
    try {
      if (window.location.pathname.indexOf('/products/') === 0) {
        window.sessionStorage.setItem(FIT_FROM_KEY, window.location.pathname + window.location.search);
      } else {
        window.sessionStorage.removeItem(FIT_FROM_KEY);
      }
    } catch (err) { /* private mode */ }
  });

  /* ---------- how many products across ---------- */

  // Remembered across collections: someone who prefers to see more at once
  // should not have to say so again on the next page.
  document.querySelectorAll('[data-grid-density]').forEach(function (control) {
    var input = control.querySelector('[data-density-input]');
    var grid = document.querySelector('.grid-products');
    if (!input || !grid) return;

    var KEY = 'hope:grid-cols';
    var min = parseInt(input.min, 10) || 2;
    var max = parseInt(input.max, 10) || 5;

    var saved;
    try { saved = parseInt(window.localStorage.getItem(KEY), 10); } catch (err) { saved = NaN; }
    // A remembered number from a page that allowed more columns than this one
    // must not push the grid past what this collection is set up for.
    if (!isNaN(saved)) input.value = Math.min(max, Math.max(min, saved));

    function apply() {
      grid.style.setProperty('--cols', input.value);
      try { window.localStorage.setItem(KEY, input.value); } catch (err) { /* private mode */ }
    }

    apply();
    input.addEventListener('input', apply);
  });

  /* ---------- size chart ---------- */

  function sizeChart() { return document.getElementById('SizeChart'); }

  function openSizeChart() {
    var el = sizeChart();
    if (!el) return;

    // The address is held on the image until it is wanted. A lazy image inside
    // a hidden box is never watched for, so it would never load however many
    // times the panel was opened; and fetching it up front would put a chart
    // on every product page for the few shoppers who open one.
    var img = el.querySelector('[data-size-chart-img]');
    if (img && !img.getAttribute('src')) {
      var src = img.getAttribute('data-src');
      if (src) img.setAttribute('src', src);
    }

    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeSizeChart() {
    var el = sizeChart();
    if (!el) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ---------- collection filter drawer ---------- */

  function filterDrawer() { return document.getElementById('FilterDrawer'); }

  function openFilters() {
    var d = filterDrawer();
    if (!d) return;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeFilters() {
    var d = filterDrawer();
    if (!d) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
  }

  // Sorting is a one-choice control, so applying it on change beats making
  // someone find a second button.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-sort-select]');
    if (!sel) return;
    var form = sel.closest('form');
    if (form) form.submit();
  });

  // An empty price box would otherwise submit as a bare parameter and sit in
  // the URL doing nothing; disabled fields are simply left out.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-filter-form]');
    if (!form) return;
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      if (!input.value) input.disabled = true;
    });
  });

  /* ---------- header search drawer ---------- */

  var searchTimer = null;
  var searchAbort = null;
  var SEARCH_MIN = 2;

  function searchDrawer() { return document.getElementById('SearchDrawer'); }

  function openSearch() {
    var d = searchDrawer();
    if (!d) return;
    d.hidden = false;

    // Opened afresh, the panel offers somewhere to go. Any results still in it
    // belong to a search the shopper has already finished with.
    var box = d.querySelector('[data-search-results]');
    if (box) box.innerHTML = '';
    showRestingPanel(true);

    // On a phone this covers the whole screen, so the page beneath must not
    // scroll away under it.
    if (window.matchMedia('(max-width: 900px)').matches) {
      document.documentElement.style.overflow = 'hidden';
    }

    // The recommendation rail has been sitting in a closed panel, where it has
    // no width and autoplay refuses to start. Now that it is on screen it can
    // be told to go.
    if (window.HOPE) {
      if (window.HOPE.initRails) window.HOPE.initRails(d);
      if (window.HOPE.startRails) window.HOPE.startRails(d);
    }

    var input = d.querySelector('[data-search-input]');
    if (input) input.focus();
  }

  function closeSearch() {
    document.documentElement.style.overflow = '';
    var d = searchDrawer();
    if (!d) return;
    d.hidden = true;
    if (searchAbort) { searchAbort.abort(); searchAbort = null; }
  }

  function renderSearch(html) {
    var d = searchDrawer();
    var box = d && d.querySelector('[data-search-results]');
    if (!box) return;
    // The section rendering API returns the whole section wrapper; take its
    // contents so the drawer's own layout stays in charge.
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var section = tmp.querySelector('#shopify-section-predictive-search') || tmp;
    box.innerHTML = section.innerHTML;
  }

  // The panel's resting content and its results are never both on screen: one
  // answers "where might I go", the other answers "here is what you asked for",
  // and showing them together makes the shopper choose which of the two the
  // page meant.
  function showRestingPanel(on) {
    var d = searchDrawer();
    var rest = d && d.querySelector('[data-search-rest]');
    if (rest) rest.hidden = !on;
  }

  function runSearch(term) {
    var d = searchDrawer();
    var box = d && d.querySelector('[data-search-results]');
    if (!box) return;

    if (term.length < SEARCH_MIN) {
      box.innerHTML = '';
      showRestingPanel(true);
      return;
    }

    showRestingPanel(false);

    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

    // Drop the in-flight request: typing fast otherwise lets an older, slower
    // response land after a newer one and show stale results.
    if (searchAbort) searchAbort.abort();
    searchAbort = typeof AbortController === 'function' ? new AbortController() : null;

    fetch(url, searchAbort ? { signal: searchAbort.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(renderSearch)
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        box.innerHTML = '<p class="search-hint">Search is unavailable right now.</p>';
      });
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-search-input]');
    if (!input) return;
    clearTimeout(searchTimer);
    var term = input.value.trim();
    searchTimer = setTimeout(function () { runSearch(term); }, 250);
  });

  /* ---------- product card colour swatches ---------- */

  // Hovering a swatch previews that colour on the card; clicking commits it and
  // repoints the card's links at the matching variant.

  function cardImage(card) { return card ? card.querySelector('img.pimg') : null; }
  function cardHoverImage(card) { return card ? card.querySelector('img.palt') : null; }

  // The card shows a second photo on hover, and it has to belong to the colour
  // on the card. A colour with only one photo shows none: revealing the one
  // that happened to be there answers a hover with a colour the shopper has
  // already moved away from, which is the whole of the bug this fixes.
  function setHoverImage(alt, src) {
    if (!alt) return;
    if (src) {
      alt.setAttribute('src', src);
      alt.style.removeProperty('display');
    } else {
      alt.style.display = 'none';
    }
  }

  function previewSwatch(card, src, altSrc) {
    var img = cardImage(card);
    if (!img || !src) return;
    if (!img.getAttribute('data-base-src')) {
      img.setAttribute('data-base-src', img.getAttribute('src') || '');
      img.setAttribute('data-base-srcset', img.getAttribute('srcset') || '');
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', src);

    var alt = cardHoverImage(card);
    if (alt && !alt.getAttribute('data-base-src')) {
      alt.setAttribute('data-base-src', alt.getAttribute('src') || '');
    }
    setHoverImage(alt, altSrc);
  }

  function restoreSwatch(card) {
    var img = cardImage(card);
    if (!img) return;
    var alt = cardHoverImage(card);
    var committed = card.getAttribute('data-swatch-src');
    if (committed) {
      img.removeAttribute('srcset');
      img.setAttribute('src', committed);
      // Back to the committed colour's pair, not to the product's own.
      setHoverImage(alt, card.getAttribute('data-swatch-src-alt'));
      return;
    }
    var base = img.getAttribute('data-base-src');
    if (base) {
      img.setAttribute('src', base);
      var baseSet = img.getAttribute('data-base-srcset');
      if (baseSet) img.setAttribute('srcset', baseSet);
    }
    if (alt) setHoverImage(alt, alt.getAttribute('data-base-src'));
  }

  function commitSwatch(sw) {
    var card = sw.closest('.pcard');
    if (!card) return;
    var src = sw.getAttribute('data-swatch-image');
    var altSrc = sw.getAttribute('data-swatch-image-alt');
    if (src) {
      previewSwatch(card, src, altSrc);
      card.setAttribute('data-swatch-src', src);
      if (altSrc) card.setAttribute('data-swatch-src-alt', altSrc);
      else card.removeAttribute('data-swatch-src-alt');
    } else {
      // No photo carries this colour. Go back to the product's own image
      // rather than leaving up the colour the shopper has just moved away
      // from, which would show one colour while another reads as selected.
      card.removeAttribute('data-swatch-src');
      card.removeAttribute('data-swatch-src-alt');
      restoreSwatch(card);
    }
    var url = sw.getAttribute('data-swatch-url');
    if (url) {
      card.querySelectorAll('a[href]').forEach(function (a) { a.href = url; });
    }
    card.querySelectorAll('.pcard-swatch').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.pcard-swatch');
    if (!sw) return;
    var card = sw.closest('.pcard');
    var src = sw.getAttribute('data-swatch-image');
    // Same rule as clicking: a colour with no photo shows the product's own,
    // never the last colour that happened to have one. The hover photo travels
    // with it, so a preview cannot leave one colour behind the other.
    if (src) previewSwatch(card, src, sw.getAttribute('data-swatch-image-alt'));
    else restoreSwatch(card);
  });

  // mouseleave does not bubble, so fall back to mouseout plus a containment test.
  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest('.pcard-colors');
    if (!row) return;
    if (e.relatedTarget && row.contains(e.relatedTarget)) return;
    restoreSwatch(row.closest('.pcard'));
  });

  /* ---------- delegated clicks ---------- */

  document.addEventListener('click', function (e) {
    var t;

    if (e.target.closest('[data-filter-open]')) {
      e.preventDefault();
      openFilters();
      return;
    }

    if (e.target.closest('[data-filter-close]')) {
      e.preventDefault();
      closeFilters();
      return;
    }

    if ((t = e.target.closest('[data-search-open]'))) {
      e.preventDefault();
      openSearch();
      return;
    }

    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeSearch();
      return;
    }

    // Clicking anywhere outside the open drawer dismisses it.
    var openDrawerEl = searchDrawer();
    if (openDrawerEl && !openDrawerEl.hidden &&
        !e.target.closest('#SearchDrawer') && !e.target.closest('[data-search-open]')) {
      closeSearch();
    }

    if ((t = e.target.closest('.pcard-swatch'))) {
      e.preventDefault();
      e.stopPropagation();
      commitSwatch(t);
      return;
    }

    if ((t = e.target.closest('[data-cart-open]'))) {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-qv-close]')) { e.preventDefault(); closeQuickView(); return; }

    if (e.target.closest('[data-size-chart-open]')) { e.preventDefault(); openSizeChart(); return; }
    if (e.target.closest('[data-size-chart-close]')) { e.preventDefault(); closeSizeChart(); return; }

    if ((t = e.target.closest('[data-qv-add]')) && !t.getAttribute('data-add-variant')) {
      e.preventDefault();
      var qvErr = document.querySelector('[data-qv-error]');
      if (qvErr) { qvErr.textContent = qv.sizeIndex >= 0 && !qv.selectedSize ? 'Please select a size to continue.' : 'This combination is sold out.'; qvErr.hidden = false; }
      return;
    }

    if ((t = e.target.closest('[data-add-variant]'))) {
      e.preventDefault();
      e.stopPropagation();
      var id = t.getAttribute('data-add-variant');
      // The look's own row must follow the picker on the page, not the variant
      // that happened to be default when the section rendered.
      if (t.hasAttribute('data-use-selected-variant')) {
        var liveInput = document.querySelector('[data-product-form] [name="id"]');
        if (liveInput && liveInput.value) id = liveInput.value;
      }
      if (!id) return;
      var fromQuickView = !!t.closest('.quick-view');
      t.disabled = true;
      addToCart(id, parseInt(t.getAttribute('data-quantity') || '1', 10))
        .then(function () { return refreshDrawer(); })
        .then(openDrawer)
        .then(function () { if (fromQuickView) closeQuickView(); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { t.disabled = false; });
      return;
    }

    if ((t = e.target.closest('[data-add-look]'))) {
      e.preventDefault();
      var ids = (t.getAttribute('data-add-look') || '').split(',').filter(Boolean);
      // Swap the placeholder for whatever the page's picker currently holds, so
      // "add the full look" adds the size the customer chose.
      var currentPlaceholder = t.getAttribute('data-look-current-variant');
      if (currentPlaceholder) {
        var lookInput = document.querySelector('[data-product-form] [name="id"]');
        if (lookInput && lookInput.value) {
          ids = ids.map(function (v) { return v === currentPlaceholder ? lookInput.value : v; });
        }
      }
      if (!ids.length) return;
      t.disabled = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      })
        .then(function (r) { if (!r.ok) throw new Error('Could not add the look'); })
        .then(refreshDrawer)
        .then(openDrawer)
        .catch(function (err) { toast(err.message); })
        .finally(function () { t.disabled = false; });
      return;
    }

    if ((t = e.target.closest('[data-line-qty]'))) {
      e.preventDefault();
      var line = parseInt(t.getAttribute('data-line'), 10);
      var qty = parseInt(t.getAttribute('data-line-qty'), 10);
      changeLine(line, qty).then(refreshDrawer);
      return;
    }

    if (e.target.closest('[data-nav-toggle]')) {
      e.preventDefault();
      var nav = document.querySelector('.site-nav');
      if (nav) nav.classList.toggle('is-open');
      // The drawer is display:none until this click, and a lazy image inside it
      // is never looked at again once the browser has decided it is invisible.
      // The pictures at the top of the drawer therefore carry their address in
      // data-src and are given it here, the moment there is something to see.
      if (nav && nav.classList.contains('is-open')) {
        nav.querySelectorAll('.nav-images img[data-src]').forEach(function (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        });
      }
      return;
    }

    if ((t = e.target.closest('[data-mega-toggle]'))) {
      e.preventDefault();
      var navItem = t.closest('.nav-item');
      if (!navItem) return;
      var wasOpen = navItem.classList.contains('is-open');
      document.querySelectorAll('.nav-item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
      if (!wasOpen) navItem.classList.add('is-open');
      return;
    }

    if ((t = e.target.closest('[data-quick-view-open]'))) {
      e.preventDefault();
      openQuickViewFor(t);
      return;
    }

    if ((t = e.target.closest('[data-look-jump]'))) {
      var lookSection = document.getElementById('shop-the-look');
      if (lookSection) {
        e.preventDefault();
        lookSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    if ((t = e.target.closest('[data-fit-tab]'))) {
      e.preventDefault();
      var tabs = t.closest('[data-fit-tabs]');
      if (!tabs) return;
      tabs.querySelectorAll('[data-fit-tab]').forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
      var position = parseFloat(t.getAttribute('data-position'));
      if (isNaN(position)) position = 50;
      var marker = tabs.querySelector('[data-fit-marker]');
      if (marker) marker.style.left = position + '%';

      // The lit reading is worked out from the position rather than stored
      // beside it, so the bead and the word under it cannot disagree, and a
      // reading added to the scale needs no edit on any category.
      var labels = tabs.querySelectorAll('[data-fit-label]');
      var gaps = labels.length - 1;
      var lit = gaps > 0 ? Math.round(position / 100 * gaps) : 0;
      labels.forEach(function (label, i) { label.classList.toggle('is-on', i === lit); });
      var nameEl = tabs.querySelector('[data-fit-name]');
      var verdictEl = tabs.querySelector('[data-fit-verdict]');
      var noteEl = tabs.querySelector('[data-fit-note]');
      if (nameEl) nameEl.textContent = t.getAttribute('data-name');
      if (verdictEl) verdictEl.textContent = t.getAttribute('data-verdict');
      if (noteEl) noteEl.textContent = t.getAttribute('data-note');
      return;
    }

    if (!e.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    }

    if ((t = e.target.closest('[data-desc-toggle]'))) {
      e.preventDefault();
      var descWrap = t.closest('[data-desc]');
      if (descWrap) {
        // Swap the excerpt for the description as written, rather than growing
        // a clamp: the two are different renderings of the same text.
        var descOpen = descWrap.classList.toggle('is-open');
        var descExcerpt = descWrap.querySelector('[data-desc-excerpt]');
        var descBody = descWrap.querySelector('[data-desc-body]');
        if (descExcerpt) descExcerpt.hidden = descOpen;
        if (descBody) descBody.hidden = !descOpen;
        t.textContent = descOpen ? (t.getAttribute('data-less') || 'Read less') : (t.getAttribute('data-more') || 'Read more');
      }
      return;
    }

    if ((t = e.target.closest('[data-pin-check]'))) {
      e.preventDefault();
      var box = t.closest('[data-pin-box]');
      if (!box) return;
      var input = box.querySelector('[data-pin-input]');
      var msg = box.querySelector('[data-pin-msg]');
      var v = (input && input.value || '').trim();
      if (msg) {
        if (/^\d{6}$/.test(v)) {
          msg.textContent = '✓ Delivering to ' + v + ' — expected in 3–5 days. COD available.';
          msg.style.color = '#2E6B3E';
        } else {
          msg.textContent = 'Please enter a valid 6-digit pin code.';
          msg.style.color = '#A33B2A';
        }
        msg.style.display = 'block';
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeQuickView(); closeSearch(); closeFilters(); closeSizeChart(); }
  });

  /* ---------- product gallery (thumbnail rail + stage) ---------- */

  // Only the photos still on show count. Positions are computed from the
  // visible ones, so hiding a colour's photos cannot leave the rail pointing
  // at a blank slot.
  function galleryVisible(stage) {
    return Array.prototype.filter.call(stage.children, function (c) {
      return c.style.display !== 'none';
    });
  }

  function galleryMarkThumb(stage, mediaId) {
    var wrap = stage.closest('.product-gallery-wrap');
    var rail = wrap && wrap.querySelector('[data-gallery-thumbs]');
    if (!rail) return;

    var active = null;
    rail.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      var on = t.getAttribute('data-media-id') === String(mediaId);
      t.classList.toggle('is-active', on);
      if (on) active = t;
    });
    if (!active) return;

    // Nudge the rail's own scroll, never the page's: scrollIntoView here would
    // drag the whole page when the gallery sits off-screen.
    var top = active.offsetTop;
    var bottom = top + active.offsetHeight;
    if (top < rail.scrollTop) rail.scrollTop = top;
    else if (bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = bottom - rail.clientHeight;
  }

  // Each item is exactly one stage wide, so scroll to an absolute offset rather
  // than by a relative amount — repeated relative steps accumulate rounding
  // error and drift off the snap points.
  // The glide comes from scroll-behavior in the stylesheet rather than from
  // scrollTo's own smooth option, which a snap container ignores outright in
  // some engines. Assigning scrollLeft is honoured everywhere.
  function galleryShow(item, behavior) {
    var stage = item.closest('.product-gallery');
    if (!stage || !stage.clientWidth) return;
    var index = galleryVisible(stage).indexOf(item);
    if (index < 0) return;

    if (behavior === 'auto') {
      // Changing colour is a cut, not a browse: gliding past photos of the
      // colour being left behind reads as the gallery losing its place.
      var previous = stage.style.scrollBehavior;
      stage.style.scrollBehavior = 'auto';
      stage.scrollLeft = index * stage.clientWidth;
      stage.style.scrollBehavior = previous;
    } else {
      stage.scrollLeft = index * stage.clientWidth;
    }
    galleryMarkThumb(stage, item.getAttribute('data-media-id'));
  }

  document.querySelectorAll('[data-gallery-thumbs]').forEach(function (rail) {
    var wrap = rail.closest('.product-gallery-wrap');
    var stage = wrap && wrap.querySelector('.product-gallery');
    if (!stage) return;

    rail.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var item = stage.querySelector('[data-gallery-item][data-media-id="' + thumb.getAttribute('data-media-id') + '"]');
      if (item) galleryShow(item);
    });

    // A swipe on a phone, or a trackpad flick on desktop, moves the stage
    // without going through the rail; follow it once it settles.
    var settle;
    stage.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var list = galleryVisible(stage);
        if (!list.length || !stage.clientWidth) return;
        var index = Math.round(stage.scrollLeft / stage.clientWidth);
        var item = list[Math.max(0, Math.min(index, list.length - 1))];
        if (item) galleryMarkThumb(stage, item.getAttribute('data-media-id'));
      }, 90);
    });
  });

  /* ---------- product form (variant picker) ---------- */

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var optionCount = parseInt(root.getAttribute('data-option-count') || '1', 10);
    var selected = [];
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var active = group.querySelector('.is-active');
      selected[idx] = active ? active.getAttribute('data-value') : null;
    });

    function currentVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    // Show only the media tagged with this colour. Returns false when nothing is
    // tagged for it, so the caller can fall back to the variant's own media.
    //
    // Three rules, in order:
    //   1. no photo tagged for this colour -> show everything, never blank
    //   2. a photo with no colour (size chart, fabric shot) -> always visible
    //   3. otherwise -> visible only when its colour is the chosen one
    //
    // Matching is an exact handle comparison, not a substring: this catalogue
    // has Blue and Navy Blue on the same product, and "contains" would show both.
    function filterGallery(colorValue) {
      var items = root.querySelectorAll('[data-gallery-item]');
      if (!items.length || !colorValue) return false;

      var wanted = handleize(colorValue);
      var tagged = Array.prototype.filter.call(items, function (it) {
        return it.getAttribute('data-media-color') === wanted;
      });
      // The rail is hidden in step with the stage, or it would offer thumbnails
      // that scroll nowhere.
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      var reveal = function (el) { el.style.display = ''; };
      var applyTo = function (el) {
        var mediaColor = el.getAttribute('data-media-color');
        el.style.display = (!mediaColor || mediaColor === wanted) ? '' : 'none';
      };

      if (!tagged.length) {
        items.forEach(reveal);
        thumbs.forEach(reveal);
        return false;
      }

      items.forEach(applyTo);
      thumbs.forEach(applyTo);

      // The stage may be parked on a photo that has just been hidden. Jump
      // rather than glide: this is a colour change, not a browse.
      var firstVisible = Array.prototype.find.call(items, function (it) {
        return it.style.display !== 'none';
      });
      if (firstVisible) galleryShow(firstVisible, 'auto');
      return true;
    }

    // Fallback for shops that do not name colours in image alt text: bring the
    // variant's own featured image up on the stage.
    function focusVariantMedia(v) {
      if (!v || !v.featured_media_id) return false;
      var item = root.querySelector('[data-gallery-item][data-media-id="' + v.featured_media_id + '"]');
      if (!item) return false;
      galleryShow(item, 'auto');
      return true;
    }

    // Colour lives in the URL by name, not by variant id: ?color=dusty-wine
    // reads as something a person can share, and is restored on arrival.
    function handleize(value) {
      return String(value).toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    var colorGroup = root.querySelector('[data-option-color]');

    function writeColorUrl(value) {
      if (!window.history || !window.history.replaceState) return;
      // A quick-add sheet must never rewrite the page's address.
      if (root.closest('.quick-view')) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('color', handleize(value));
        // replaceState, not pushState: otherwise Back walks through every
        // colour tried before it leaves the page.
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* no URL support: leave the address bar alone */ }
    }

    function applyColorFromUrl() {
      if (!colorGroup) return;
      var wanted;
      try {
        wanted = new URLSearchParams(window.location.search).get('color');
      } catch (err) { return; }
      if (!wanted) return;
      var match = Array.prototype.filter.call(
        colorGroup.querySelectorAll('[data-value]'),
        function (b) { return handleize(b.getAttribute('data-value')) === wanted; }
      )[0];
      // Reuse the normal click path so gallery, price and form all follow.
      if (match && !match.classList.contains('is-active')) match.click();

      // On a phone the row is a swipeable strip, so the colour a shared link
      // asks for may be sitting off its right-hand edge. Bring it into the
      // strip's own view — never the page's, which would jump the reader.
      if (match && colorGroup.scrollWidth > colorGroup.clientWidth) {
        var left = match.offsetLeft - (colorGroup.clientWidth - match.offsetWidth) / 2;
        colorGroup.scrollLeft = Math.max(0, left);
      }
    }

    function update() {
      var v = currentVariant();
      var idInput = root.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var addBtn = root.querySelector('[data-main-add]');
      var buyBtn = root.querySelector('[data-main-buy]');
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        var ok = v.available;
        if (addBtn) {
          addBtn.disabled = !ok;
          addBtn.setAttribute('data-add-variant', v.id);
          addBtn.textContent = ok ? (addBtn.getAttribute('data-label') || 'Add to Cart') : 'Sold Out';
        }
        if (buyBtn) buyBtn.disabled = !ok;

        // The sticky bar shows the same offer, so it must never disagree with
        // the button it stands in for.
        var stickyBtn = root.querySelector('[data-sticky-add]');
        if (stickyBtn) {
          stickyBtn.disabled = !ok;
          stickyBtn.setAttribute('data-add-variant', v.id);
          stickyBtn.textContent = ok ? (stickyBtn.getAttribute('data-label') || 'Add to Bag') : 'Sold Out';
        }
      }
    }

    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var isColor = group.hasAttribute('data-option-color');
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.classList.contains('is-disabled')) return;
        e.preventDefault();
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[idx] = btn.getAttribute('data-value');
        var nameEl = group.querySelector('[data-option-selected-name]') || root.querySelector('[data-option-selected-name="' + idx + '"]');
        if (nameEl) nameEl.textContent = selected[idx];
        update();
        if (typeof refreshStickyBar === 'function') refreshStickyBar();
        if (isColor) {
          writeColorUrl(selected[idx]);
          if (!filterGallery(selected[idx])) focusVariantMedia(currentVariant());
        }
      });
      if (isColor && selected[idx]) filterGallery(selected[idx]);
    });

    update();
    // Arrived on a shared ?color= link: select it once everything is wired.
    applyColorFromUrl();

    // The finder's promise: having answered once, the size is already chosen on
    // every product page afterwards. Only a size that this product actually
    // sells, and only at the moment the page is set up — the highlight standing
    // there then is Shopify's first-variant default, not anything the shopper
    // said, and the size they worked out beats it. Nothing they click later is
    // ever touched, because this runs once and never again.
    function applyFitSize() {
      var wanted = readFitSize();
      if (!wanted) return;
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        if (group.hasAttribute('data-option-color')) return;
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        if (fitSizeMatches(selected[idx], wanted)) return;
        var match = Array.prototype.filter.call(
          group.querySelectorAll('[data-value]'),
          function (b) {
            return !b.classList.contains('is-disabled') && fitSizeMatches(b.getAttribute('data-value'), wanted);
          }
        )[0];
        if (match) match.click();
      });
    }

    /* ---- sticky buy bar (phones) ---- */

    var stickyBar = root.querySelector('[data-sticky-atc]');
    var stickyActions = root.querySelector('[data-sticky-actions]');
    var stickySelect = root.querySelector('[data-sticky-select]');
    // Ask the stylesheet, not a second copy of its breakpoint: the bar is only
    // laid out on phones, so "is it displayed" is the phone test, and the two
    // can never drift apart.
    function onPhone() {
      return !!stickyBar && getComputedStyle(stickyBar).display !== 'none';
    }

    // Groups the customer must choose from. Colour is excluded: it is visual,
    // always shows something, and a swatch is already highlighted.
    function pickerGroups() {
      return Array.prototype.filter.call(
        root.querySelectorAll('[data-option-index]'),
        function (g) { return !g.hasAttribute('data-option-color'); }
      );
    }

    function everythingChosen() {
      return pickerGroups().every(function (g) {
        var idx = parseInt(g.getAttribute('data-option-index'), 10);
        return !!selected[idx];
      });
    }

    function refreshStickyBar() {
      if (!stickyBar || !stickyActions || !stickySelect) return;
      var ready = everythingChosen();
      stickyActions.hidden = !ready;
      stickySelect.hidden = ready;
    }

    // A prompt to choose a size is a lie while one is already highlighted, so on
    // phones the non-colour options start genuinely empty and the customer picks
    // deliberately. Desktop keeps Shopify's default selection.
    if (onPhone() && pickerGroups().length) {
      pickerGroups().forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-option-index'), 10);
        g.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        selected[idx] = null;
      });
    }

    // After the clearing, never before it: a size the shopper worked out in the
    // finder is a deliberate choice of theirs, and starting the page empty on a
    // phone must not throw it away.
    applyFitSize();
    refreshStickyBar();

    if (stickySelect) {
      stickySelect.addEventListener('click', function () {
        var first = pickerGroups()[0];
        if (!first) return;
        // scroll its label into view, not the swatches, so the heading is legible
        var target = first.previousElementSibling || first;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    var stickyBuy = root.querySelector('[data-sticky-buy]');
    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        // Hand off to the real form button so checkout is Shopify's own submit.
        var realBuy = root.querySelector('[data-main-buy]');
        if (realBuy && !realBuy.disabled) realBuy.click();
      });
    }
  });

  // The sticky gallery parks below the header, and the header is not a fixed
  // height: the nav wraps to a second row on narrower desktops. Publish the
  // measured height so the stylesheet can offset against the real thing.
  function syncHeaderHeight() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  // The heading used to draw a rule under itself once it pinned. It does not
  // pin any more, so there is nothing to mark and nothing to watch the scroll
  // for.

  window.addEventListener('resize', syncHeaderHeight);
  document.addEventListener('DOMContentLoaded', syncHeaderHeight);
  // Again once webfonts have swapped: a different face can wrap the nav onto
  // another row, which moves the header's height by far more than a pixel, and
  // the sticky gallery is sized against it.
  window.addEventListener('load', syncHeaderHeight);
  syncHeaderHeight();

  document.addEventListener('DOMContentLoaded', syncHeaderCount);
  syncHeaderCount();

  // The gallery pill is pointless when Shop the Look was skipped for this
  // product, so it stays hidden unless that section is actually on the page.
  function revealLookPill() {
    if (!document.getElementById('shop-the-look')) return;
    document.querySelectorAll('[data-look-jump]').forEach(function (pill) {
      pill.removeAttribute('hidden');
    });
  }
  document.addEventListener('DOMContentLoaded', revealLookPill);
  revealLookPill();

  // A short description simply renders without a toggle — the template knows
  // the full text length, so there is nothing to measure here.

  /* ---------- offers ---------- */

  // Coupons: a row of tickets, each of which either copies its code or puts it
  // on the bag, as the shop chose. The row scrolls sideways and fades at
  // whichever edge has more to come.
  (function () {
    var box = document.querySelector('[data-offers]');
    if (!box) return;

    var row = box.querySelector('[data-coupon-row]');
    if (row) {
      // Kept true to where the row actually is: a hint that there is more
      // only while there is. A row that fits whole shows no fade at all.
      var edges = function () {
        var max = row.scrollWidth - row.clientWidth;
        row.classList.toggle('has-before', row.scrollLeft > 2);
        row.classList.toggle('has-after', row.scrollLeft < max - 2);
      };
      row.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      if (window.ResizeObserver) new ResizeObserver(edges).observe(row);
      edges();
    }

    /* -- copying -- */

    // The older way: select the code in a field nobody sees and ask the
    // browser to copy the selection.
    function copyBySelection(text) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(field);
      return ok;
    }

    // The clipboard API first. It is refused more often than it is missing —
    // an in-app browser's permissions, a page that has lost focus — so a
    // refusal falls through to the older way rather than straight to failure.
    function copyText(text) {
      var viaApi = (navigator.clipboard && window.isSecureContext)
        ? navigator.clipboard.writeText(text)
        : Promise.reject(new Error('no clipboard api'));
      return viaApi.catch(function () {
        if (!copyBySelection(text)) throw new Error('copy refused');
      });
    }

    box.addEventListener('click', function (e) {
      var ticket = e.target.closest('[data-coupon-copy]');
      if (!ticket) return;
      var code = ticket.getAttribute('data-coupon-copy');
      var word = ticket.querySelector('[data-offer-state]');

      copyText(code).then(function () {
        ticket.classList.add('is-copied');
        if (word) word.textContent = 'Copied';
        toast(code + ' copied. Paste it at checkout.');
        clearTimeout(ticket.copyTimer);
        ticket.copyTimer = setTimeout(function () {
          ticket.classList.remove('is-copied');
          if (word) word.textContent = word.getAttribute('data-rest') || 'Copy';
        }, 2200);
      }).catch(function () {
        // Nothing reached the clipboard, so the code is said instead: it can
        // still be read off the message and typed in.
        toast('Could not copy. The code is ' + code + '.');
      });
    });

    /* -- applying -- */

    // A ticket puts its code on the bag and takes it off again, through
    // /cart/update.js. That endpoint replaces rather than accumulates, which is
    // what makes "one at a time" true rather than merely drawn: Shopify's
    // /discount/<code> route keeps every code it has ever been handed, so two
    // tickets could both be honoured while only one read as applied.
    //
    // It also clears, which /discount cannot, and clearing is what lets an
    // offer come off again — one a shopper has changed their mind about should
    // not follow them to the till.
    var inputs = [].slice.call(box.querySelectorAll('[data-offer-input]'));
    if (!inputs.length) return;

    var busy = false;

    function say(input, word, state) {
      var ticket = input.closest('[data-offer]');
      if (!ticket) return;
      ticket.classList.toggle('is-working', state === 'working');
      ticket.classList.toggle('is-failed', state === 'failed');
      ticket.classList.toggle('is-on', state === 'on');
      var out = ticket.querySelector('[data-offer-state]');
      // No word puts the ticket back to its resting label rather than to
      // nothing: that label is the only thing on it inviting a tap.
      if (out) out.textContent = word || out.getAttribute('data-rest') || '';
    }

    function clearAllLabels() { inputs.forEach(function (i) { say(i, ''); }); }

    function put(code) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: code })
      }).then(function (r) {
        // Shopify answers 503 to cart writes that arrive too quickly. One
        // unhurried retry is the difference between a ticket that works and
        // one that fails when someone changes their mind twice.
        if (r.status === 503) {
          return new Promise(function (done) { window.setTimeout(done, 700); })
            .then(function () {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ discount: code })
              });
            });
        }
        return r;
      });
    }

    // Ask the bag what it actually holds rather than trusting the write: a code
    // Shopify has taken but will not honour should not be reported as applied.
    function verify(code) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var held = (cart.discount_codes || []).filter(function (d) { return d.code === code; })[0];
          return { held: !!held, applicable: held ? held.applicable : false, items: cart.item_count };
        });
    }

    function turnOn(input) {
      var code = input.value;
      if (!code || busy) return;
      busy = true;
      clearAllLabels();
      say(input, 'Applying', 'working');

      put(code)
        .then(function (r) { if (!r.ok) throw new Error('refused'); return verify(code); })
        .then(function (state) {
          if (!input.checked) return;
          if (!state.held) { throw new Error('not taken'); }

          // Shopify took the code but will not honour it against this bag. A
          // ticket left reading Applied for an offer that gives nothing is the
          // worst of the three states: it reads as money saved right up until
          // the total says otherwise. So it comes off, the code comes off the
          // bag with it, and the reason is said out loud.
          //
          // An empty bag cannot meet any condition, so this is only judged once
          // there is something to judge against.
          if (!state.applicable && state.items > 0) {
            input.checked = false;
            input.removeAttribute('data-on');
            say(input, '');
            toast(code + ' does not apply to what is in your bag.');
            return put('');
          }

          say(input, 'Applied', 'on');
        })
        .catch(function () {
          if (!input.checked) return;
          say(input, 'Could not apply', 'failed');
          input.checked = false;
          input.removeAttribute('data-on');
        })
        .then(function () { busy = false; });
    }

    function turnOff(input) {
      if (busy) return;
      busy = true;
      say(input, 'Removing', 'working');
      put('')
        .then(function () { say(input, ''); })
        .catch(function () { say(input, 'Could not remove', 'failed'); })
        .then(function () { busy = false; });
    }

    // A radio cannot be unticked by clicking it, and these have to be: the
    // exclusivity is worth having, and so is changing your mind back to none.
    inputs.forEach(function (input) {
      input.addEventListener('click', function () {
        if (input.getAttribute('data-on')) {
          input.checked = false;
          input.removeAttribute('data-on');
          turnOff(input);
          return;
        }
        inputs.forEach(function (i) { i.removeAttribute('data-on'); });
        input.setAttribute('data-on', '1');
        turnOn(input);
      });
    });

    // Nothing is remembered across pages. What the bag holds is the truth, and
    // it is asked here rather than guessed from a note left in this browser.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        inputs.forEach(function (i) {
          if (codes.indexOf(i.value) !== -1) {
            i.checked = true;
            i.setAttribute('data-on', '1');
            say(i, 'Applied', 'on');
          }
        });
      })
      .catch(function () { /* the bag will answer next time */ });
  })();

  /* ---------- what this visitor has looked at ---------- */

  // Only the handle is kept, never the card: a price or a sold-out state
  // written down today would be shown as fact next week. The section that
  // reads this list asks the shop to draw each card fresh.
  //
  // Kept in this browser and nowhere else — it is one person's browsing, and
  // it has no business on a server.
  (function () {
    var form = document.querySelector('[data-product-form][data-product-handle]');
    if (!form) return;
    var handle = form.getAttribute('data-product-handle');
    if (!handle) return;

    var KEY = 'hope:recently-viewed';
    var KEEP = 12;

    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) list = [];
      // Moved to the front rather than added again, so looking at something
      // twice does not fill the row with one product.
      list = list.filter(function (h) { return h && h !== handle; });
      list.unshift(handle);
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP)));
    } catch (err) { /* private mode, or storage full */ }
  })();

  /* ---------- hero slideshow ---------- */

  function initHero(root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (slides.length < 2) return;
    var index = 0;
    var interval = (parseInt(root.getAttribute('data-hero-interval'), 10) || 6) * 1000;
    var timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === index); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === index); });
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); restart(); }); });

    restart();
  }

  document.querySelectorAll('[data-hero]').forEach(initHero);

  /* ---------- looping product rail ---------- */

  function initRail(wrap) {
    var rail = wrap.querySelector('[data-rail]');
    if (!rail) return;

    var interval = parseFloat(wrap.getAttribute('data-interval')) || 4;
    var autoplay = wrap.getAttribute('data-autoplay') !== 'false';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // The row loops by running its list twice: scrolling past the first copy is
    // reset by exactly one copy's width, which lands on the identical card, so
    // the row never shows a seam or an end.
    //
    // That copy is made here rather than by Liquid. Rendering the list twice on
    // the server doubled the markup of every rail on every page — and two of
    // them, the header's search row and the cart drawer's, sit in the page
    // whether or not anyone opens them. Cloning a node costs nothing to send.
    //
    // A rail that arrives with clones already in it keeps them: reels build
    // theirs in Liquid, and recently-viewed builds its own after fetching.
    if (!rail.querySelector('.rail-item--clone')) {
      var originals = rail.querySelectorAll('.rail-item');
      if (originals.length) {
        var copies = document.createDocumentFragment();
        originals.forEach(function (item) {
          var copy = item.cloneNode(true);
          copy.classList.add('rail-item--clone');
          // The theme editor binds to these attributes and to ids. A second
          // element answering to either would have the editor highlighting the
          // decoration, or a label pointing at the wrong field.
          copy.removeAttribute('data-shopify-editor-block');
          copy.removeAttribute('id');
          copy.querySelectorAll('[data-shopify-editor-block], [id]').forEach(function (el) {
            el.removeAttribute('data-shopify-editor-block');
            el.removeAttribute('id');
          });
          copies.appendChild(copy);
        });
        rail.appendChild(copies);
      }
    }

    // The duplicated half is decoration: keep it out of the tab order and away
    // from screen readers so every product is announced once.
    rail.querySelectorAll('.rail-item--clone').forEach(function (item) {
      item.setAttribute('aria-hidden', 'true');
      item.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });

    // Everything below is measured from where the cards actually are, never
    // from a card's width plus a gap. A rail can be set to show one and a half
    // cards, which makes every width a fraction; adding those up card by card
    // drifts, and a wrap that is a few pixels out is a wrap you can see. The
    // distance between two cards is exact, whatever the arithmetic behind it.
    function items() { return rail.querySelectorAll('.rail-item'); }

    function stepSize() {
      var list = items();
      if (list.length > 1) return list[1].offsetLeft - list[0].offsetLeft;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
      return list.length ? list[0].getBoundingClientRect().width + gap : 260;
    }

    // The exact distance from a card to the same card in the second copy. Taken
    // from the first clone's own position, so gaps, fractions and rounding are
    // all already accounted for — jump by this and the row cannot be seen to
    // move, because what replaces the view is identical to what left it.
    function copyWidth() {
      var list = items();
      var clone = rail.querySelector('.rail-item--clone');
      if (!clone || !list.length) return 0;
      return clone.offsetLeft - list[0].offsetLeft;
    }

    // Where a given card sits, again measured rather than multiplied.
    function positionOf(index) {
      var list = items();
      if (!list.length) return 0;
      if (index < 0) index = 0;
      if (index > list.length - 1) index = list.length - 1;
      return list[index].offsetLeft - list[0].offsetLeft;
    }

    function nearestIndex() {
      var list = items();
      var best = 0;
      var gap = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs((list[i].offsetLeft - list[0].offsetLeft) - rail.scrollLeft);
        if (d < gap) { gap = d; best = i; }
      }
      return best;
    }

    function furthest() { return rail.scrollWidth - rail.clientWidth; }

    // A rail loops by scrolling one whole copy and jumping back. That needs the
    // scrollable distance to be longer than a copy — which it is not when a
    // collection holds fewer products than fit on the screen. Four products
    // shown five at a time can never reach the jump-back point, and no amount
    // of counting fixes that: there is nothing there to scroll to.
    function canLoop() {
      var w = copyWidth();
      return w > 0 && furthest() > w + 1;
    }

    // The last card that can actually be scrolled to, for the rails that cannot
    // loop and must simply stop somewhere.
    function lastReachableIndex() {
      var list = items();
      var max = furthest();
      var best = 0;
      for (var i = 0; i < list.length; i++) {
        if (positionOf(i) <= max + 1) best = i;
      }
      return best;
    }

    // Returns true when it reset, so the caller can shift its index by the same
    // amount and stay in step.
    function wrapAround() {
      var w = copyWidth();
      if (w <= 0) return false;
      if (rail.scrollLeft >= w) { rail.scrollLeft -= w; return true; }
      return false;
    }

    var paused = false;
    var timer = null;

    // Hold still while someone is reading, hovering or tabbing through it.
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      wrap.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (ev) {
      wrap.addEventListener(ev, function () { paused = false; }, { passive: true });
    });

    // Card index we are heading for. Held explicitly rather than derived from
    // scrollLeft, which reads a half-finished position mid-animation and makes
    // repeated arrow clicks resolve to the same target — the carousel would just
    // ignore them.
    var targetIndex = null;
    var settleTimer = null;

    // Advance exactly one card at a time, for ever: 1 2 3 4 1 2 3 4, with the
    // return to the first card being no different to any other step.
    function nudge(direction) {
      var list = items();
      if (!list.length) return;
      var perCopy = list.length / 2;
      var w = copyWidth();
      if (targetIndex === null) targetIndex = nearestIndex();

      // Too few products to loop. Step to the end and come back to the start —
      // the return is visible, which cannot be helped when there is only one
      // copy's worth of scrolling to be had, but the row never seizes up.
      if (!canLoop()) {
        var last = lastReachableIndex();
        targetIndex += direction;
        if (targetIndex > last) targetIndex = 0;
        if (targetIndex < 0) targetIndex = last;
        rail.scrollTo({ left: positionOf(targetIndex), behavior: 'smooth' });
        return;
      }

      // Bring the position back into the first copy before deciding anything.
      // The second copy is identical, so this is not visible — but it is what
      // keeps the row looping. Without it the index walked off the end of the
      // track whenever somebody clicked faster than the animation settled, and
      // every click after that asked for a place the browser will not scroll
      // to, so the row simply stopped while the arrow went on being pressed.
      while (w > 0 && rail.scrollLeft >= w - 1) {
        rail.scrollLeft -= w;
        targetIndex -= perCopy;
      }
      if (targetIndex < 0) targetIndex = 0;

      // The browser clamps scrollLeft at 0, so going back from the very start
      // would do nothing. Jump forward one copy first — same cards, so the jump
      // is invisible — then animate backwards into it.
      if (direction < 0 && targetIndex <= 0) {
        rail.scrollLeft += w;
        targetIndex += perCopy;
      }

      targetIndex += direction;
      if (targetIndex > list.length - 1) targetIndex = list.length - 1;

      // An absolute card position, measured rather than multiplied out.
      rail.scrollTo({ left: positionOf(targetIndex), behavior: 'smooth' });

      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        // Move the index with the wrap rather than re-deriving it from
        // scrollLeft, which may still be mid-animation and would silently
        // discard clicks that arrived during it.
        if (wrapAround()) targetIndex -= items().length / 2;
      }, 620);
    }

    function play() {
      clearInterval(timer);
      if (!autoplay || reduceMotion) return;
      if (rail.scrollWidth <= rail.clientWidth + 4) return;
      timer = setInterval(function () { if (!paused) nudge(1); }, Math.max(interval, 1.5) * 1000);
    }

    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    // Restart the clock after a manual step, so it does not fire mid-animation.
    if (prev) prev.addEventListener('click', function () { nudge(-1); play(); });
    if (next) next.addEventListener('click', function () { nudge(1); play(); });

    // Arrows on a row that already shows everything are decoration, and worse
    // than decoration — they invite a click that cannot do anything.
    function syncArrows() {
      var nothingToScroll = furthest() <= 4;
      [prev, next].forEach(function (b) { if (b) b.hidden = nothingToScroll; });
    }
    syncArrows();

    // The cart drawer starts hidden, where a rail measures zero and autoplay
    // cannot start. Expose play so opening the drawer can kick it off — and
    // the arrow check with it, since a rail measured while closed looks like
    // one with nothing to scroll, and its arrows were hidden on that basis.
    wrap.railPlay = play;
    wrap.railSyncArrows = syncArrows;

    // A rail can be a plain grid at one breakpoint, so re-evaluate on resize:
    // play() stops itself when there is nothing to scroll, and restarts when
    // the rail becomes a carousel again.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { targetIndex = null; syncArrows(); play(); }, 200);
    });

    play();
  }

  // Safe to call repeatedly: rails already wired are skipped. Needed because the
  // cart drawer replaces its own markup whenever the cart changes.
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-rail-carousel]').forEach(function (wrap) {
      if (wrap.getAttribute('data-rail-ready')) return;
      wrap.setAttribute('data-rail-ready', '1');
      initRail(wrap);
    });
  }

  // Reachable from a section that builds its own rail after the page has
  // loaded — recently-viewed fetches its cards, so its rail does not exist yet
  // when the sweep below runs.
  window.HOPE = window.HOPE || {};
  window.HOPE.initRails = initRails;
  // A rail inside something that opens measures nothing until it is opened, so
  // autoplay cannot start at load. Whatever opens it says so.
  window.HOPE.startRails = startRailsIn;

  function startRailsIn(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-rail-carousel]').forEach(function (wrap) {
      if (typeof wrap.railSyncArrows === 'function') wrap.railSyncArrows();
      if (typeof wrap.railPlay === 'function') wrap.railPlay();
    });
  }

  initRails();

  /* ---------- reels ---------- */

  document.querySelectorAll('[data-reels]').forEach(function (wrap) {
    var wantsAutoplay = wrap.getAttribute('data-reel-autoplay') === 'true';
    var quiet = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markPlaying(video) {
      var card = video.closest('[data-reel]');
      if (card) card.classList.toggle('is-playing', !video.paused);
    }

    // Only what is on screen plays. A row of a dozen films otherwise has every
    // one of them decoding at once, most of them behind the fold.
    if (wantsAutoplay && !quiet && 'IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () { /* refused, leave the still */ });
          } else {
            video.pause();
          }
          markPlaying(video);
        });
      }, { threshold: 0.5 });

      wrap.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        watcher.observe(video);
        ['play', 'pause'].forEach(function (ev) {
          video.addEventListener(ev, function () { markPlaying(video); });
        });
      });
    }

    // Tapping the film plays or pauses it, whether or not it started on its
    // own. The footer link keeps working: that is a different intention.
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var card = e.target.closest('[data-reel]');
      if (!card) return;
      var video = card.querySelector('video');
      if (!video) return;
      e.preventDefault();
      if (video.paused) {
        video.muted = true;
        var started = video.play();
        if (started && started.catch) started.catch(function () { /* ignore */ });
      } else {
        video.pause();
      }
      markPlaying(video);
    });
  });

  /* ---------- auto-advancing snap strip ---------- */

  // A plainer relative of the product rail, for a strip that is only a strip at
  // some widths. It does not loop: the rail's endless scroll is built from
  // cloned cards, and duplicating reviews would have a screen reader read every
  // one of them twice. This walks to the end and returns to the start.
  document.querySelectorAll('[data-autoscroll]').forEach(function (strip) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var seconds = parseFloat(strip.getAttribute('data-interval')) || 7;

    var paused = false;
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      strip.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (ev) {
      strip.addEventListener(ev, function () { paused = false; }, { passive: true });
    });

    setInterval(function () {
      // The same markup is a plain grid on desktop, with nothing to scroll.
      if (paused || strip.scrollWidth <= strip.clientWidth + 4) return;
      var card = strip.firstElementChild;
      if (!card) return;

      var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(strip).columnGap) || 0);
      var atEnd = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 4;
      // Assigning scrollLeft, with the glide coming from scroll-behavior in the
      // stylesheet: a snap container ignores scrollTo's own smooth option in
      // some engines.
      strip.scrollLeft = atEnd ? 0 : strip.scrollLeft + step;
    }, Math.max(seconds, 2) * 1000);
  });

  /* ---------- hero background video ---------- */

  // Sources sit in data-src until their layer matches the current breakpoint, so
  // a phone never downloads the desktop film (and vice versa).
  var heroMobileQuery = window.matchMedia('(max-width: 749px)');

  function activateHeroMedia() {
    var wantMobile = heroMobileQuery.matches;
    document.querySelectorAll('[data-hero-media]').forEach(function (wrap) {
      var video = wrap.querySelector('video[data-hero-video]');
      if (!video) return;

      // Any section can hold breakpoint media, not just hero slides.
      var scope = wrap.closest('[data-media-layers]') || wrap.closest('[data-hero-slide]');
      var mobileLayerActive = wantMobile && scope && scope.classList.contains('has-mobile-media');
      var layerWanted = wrap.getAttribute('data-hero-media') === 'mobile'
        ? mobileLayerActive
        : !mobileLayerActive;

      if (!layerWanted) { video.pause(); return; }

      if (!video.getAttribute('data-loaded')) {
        video.querySelectorAll('source[data-src]').forEach(function (s) {
          s.setAttribute('src', s.getAttribute('data-src'));
        });
        video.setAttribute('data-loaded', '1');
        video.load();
      }
      var played = video.play();
      // Autoplay can still be refused; the poster frame stands in.
      if (played && played.catch) played.catch(function () {});
    });
  }

  if (heroMobileQuery.addEventListener) {
    heroMobileQuery.addEventListener('change', activateHeroMedia);
  } else if (heroMobileQuery.addListener) {
    heroMobileQuery.addListener(activateHeroMedia);
  }
  document.addEventListener('DOMContentLoaded', activateHeroMedia);
  activateHeroMedia();
})();
